<template>
  <v-container fluid>
    <v-container fluid class="primary white--text no-gutters">
      <v-content class="mb-10">
        <v-row>
          <v-col cols="12" md="2"></v-col>
          <v-col cols="12" md="7">
            <h2 class="font-weight-bold">Sasa<span class="red--text">Pay</span> Partner Network</h2>
            <div class="mt-10">
              <typewriter
                  class="typewriter"
                  :replace="replace"
                  :type-interval="100"
                  :replace-interval="1000"
              >
                <div>
                  <h1>SasaPay ensures seamless connectivity across different platforms including financial institutions, fitness and retail outlets among others</h1>
                </div>
              </typewriter>
            </div>
            <div class="mt-10">
              <v-btn large class="error font-weight-bold rounded">Discover Our Partners</v-btn>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <v-img src="@/assets/sp/partner.png"/>
          </v-col>
        </v-row>
      </v-content>
    </v-container>
    <v-content class="mt-5 ">
      <v-row>
        <v-col cols="12" md="2"></v-col>
        <v-col cols="12" md="8">
          <h1>SasaPay Engage</h1>
          <div class="mt-2">
            <p>
              We’re reaching out to enablers, identifying and prequalifying networks of peers that help you implement our products and services in a faster and easier way.
              Register with SasaPay Engage for help to integrate our portfolio into your customer offering, or to start on the road to partnership.
            </p>
          </div>
        </v-col>
      </v-row>
    </v-content>
    <v-content>
      <!--BEGIN -->
      <v-row>
        <v-col class="mx-auto" cols="12" md="8">

          <!--BEGIN row 1-->
          <v-row class="mt-5">
            <v-col cols="12" md="4">
              <v-card elevation="2" height="95%" class="py-10">
                <v-row class="mx-auto">
                  <v-img height="150" width="200" src="@/assets/sp/eblogo-2.png"/>
                </v-row>
                <v-card-title>E-Biashara</v-card-title>
                <v-card-text class="mt-2">
                  SasaPay powers E-Biashara...
                </v-card-text>
                <v-card-actions class="bottom-0 ml-2">
                  <RouterLink class="text-decoration-none" to="/">Learn More <v-icon color="error">mdi-arrow-right</v-icon></RouterLink>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card elevation="2" height="95%" class="py-10">
                <v-row class="mx-auto">
                  <v-img height="150" width="100%" src="@/assets/sp/aziz-final.png"/>
                </v-row>
                <v-card-title>PostPay</v-card-title>
                <v-card-text class="mt-2">
                  SasaPay powers Aziz Remit...
                </v-card-text>
                <v-card-actions class="bottom-0 ml-2">
                  <RouterLink class="text-decoration-none" to="/">Learn More <v-icon color="error">mdi-arrow-right</v-icon></RouterLink>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card elevation="2" height="95%" class="py-10">
                <v-row class="mx-auto">
                  <v-img height="100" width="100" src="@/assets/sp/logoposta.jpeg"/>
                </v-row>
                <v-card-title>PostaPay</v-card-title>
                <v-card-text class="mt-2">
                  SasaPay powers Posta ...
                </v-card-text>
                <v-card-actions class="bottom-0 ml-2">
                  <RouterLink class="text-decoration-none" to="/">Learn More <v-icon color="error">mdi-arrow-right</v-icon></RouterLink>
                </v-card-actions>
              </v-card>
            </v-col>

          </v-row>
          <!--END Row 3-->
        </v-col>
      </v-row>
      <!--END -->
    </v-content>

    <v-content class="mt-5">
      <!--BEGIN -->
      <v-row>
        <v-col class="mx-auto" cols="12" md="8">
        <v-card flat>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="8">
                <h1 class="mt-3">Discover Your Way To Success</h1>
                <div class="mt-2 py-5 line-height-4">
                  <v-divider/>
                  <h3>
                    SasaPay empowers you to make collections and disburse money in a <br/> simple, secure, and seamless way. Whether you are in search of a comprehensive payment solutions or another choice of payment for your business, we have you covered.
                  </h3>
                </div>
                <div class="mt-5">
                  <v-btn class="rounded"
                         elevation="2"
                         color="error"
                         outlined
                         @click="onSignUp"
                  >
                    Sign Up Now
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <v-img src="@/assets/sp/ipn.jpeg"/>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
          <!--END-->
        </v-col>
      </v-row>
      <!--END -->
    </v-content>
  </v-container>
</template>

<script>
import Typewriter from "typewriter-vue";
export default {
  name: "Partners",
  components: {
    Typewriter,
  },
  data: () => ({
    replace: [
      { from: "SasaPay ensures seamless connectivity across different platforms including financial institutions, fitness and retail outlets among others", to: "We allow for payment of goods and services, transfer of money and more hustle free" },
    ],
  }),
  methods: {
    onSignUp(){
      window.open('https://merchant.sasapay.me/','_blank')
    }
  }
}
</script>